import axios from 'axios'
// Define base url
const BASE_URL = '/api/v1/roles'

// Define roles module
const roles = {
  state: {
    data: {},
    errors: null
  },
  getters: {
    rolesCollection: state => {
      return state.data
    }
  },
  mutations: {
    getRolesData (state, payload) {
      state.data = payload
    },
    setRolesErrors (state, payload) {
      state.errors = payload
    }
  },
  actions: {
    async rolesGetData ({ commit }) {
      try {
        const response = await axios.get(BASE_URL)
        if (response.status === 200) {
          commit('getRolesData', response.data.data)
        }
      } catch (error) {
        commit('setRolesErrors', error)
      }
    }
  }
}

// Export the roles module
export default roles
